import React, { useRef, useState } from "react";
import { Upload, Loader2, X, Image as ImageIcon } from "lucide-react";
import { toast } from "sonner";
import { adminAxios, mediaUrl } from "../api";

// Reusable image field: shows preview, allows file upload OR pasting a URL.
const ImageField = ({ value, onChange, label = "Image", compact = false }) => {
  const inputRef = useRef(null);
  const [busy, setBusy] = useState(false);

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const r = await adminAxios.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(r.data.url);
      toast.success("Image uploaded");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Upload failed");
    } finally {
      setBusy(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  return (
    <div>
      {label && <div className="text-slate-600 text-sm mb-1.5">{label}</div>}
      <div className="flex items-center gap-3">
        <div className={`shrink-0 ${compact ? "w-12 h-12" : "w-16 h-16"} rounded-lg border border-slate-200 bg-slate-50 overflow-hidden flex items-center justify-center`}>
          {value ? (
            <img src={mediaUrl(value)} alt="" className="w-full h-full object-cover" />
          ) : (
            <ImageIcon className="w-5 h-5 text-slate-300" />
          )}
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex gap-2">
            <button type="button" onClick={() => inputRef.current?.click()} disabled={busy}
              className="inline-flex items-center gap-1.5 text-sm border border-slate-300 rounded-md px-3 py-1.5 hover:bg-slate-50 disabled:opacity-60">
              {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Upload className="w-4 h-4" />} Upload
            </button>
            {value && (
              <button type="button" onClick={() => onChange("")} className="inline-flex items-center gap-1 text-sm text-red-500 hover:underline">
                <X className="w-4 h-4" /> Remove
              </button>
            )}
          </div>
          <input value={value || ""} onChange={(e) => onChange(e.target.value)} placeholder="or paste an image URL"
            className="mt-2 w-full border border-slate-200 rounded px-2 py-1.5 text-xs" />
        </div>
      </div>
      <input ref={inputRef} type="file" accept="image/*" onChange={handleFile} className="hidden" />
    </div>
  );
};

export default ImageField;
